/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimableRewardNotificationActionData
 */
export interface ClaimableRewardNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ClaimableRewardNotificationActionData
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimableRewardNotificationActionData
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimableRewardNotificationActionData
     */
    challengeId: string;
}

/**
 * Check if a given object implements the ClaimableRewardNotificationActionData interface.
 */
export function instanceOfClaimableRewardNotificationActionData(value: object): value is ClaimableRewardNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "challengeId" in value && value["challengeId"] !== undefined;

    return isInstance;
}

export function ClaimableRewardNotificationActionDataFromJSON(json: any): ClaimableRewardNotificationActionData {
    return ClaimableRewardNotificationActionDataFromJSONTyped(json, false);
}

export function ClaimableRewardNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimableRewardNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'specifier': json['specifier'],
        'challengeId': json['challenge_id'],
    };
}

export function ClaimableRewardNotificationActionDataToJSON(value?: ClaimableRewardNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'specifier': value.specifier,
        'challenge_id': value.challengeId,
    };
}

